module.exports = __webpack_public_path__ + "static/assets/e0a0eb2b0e7ea0f0c290d75bc4d7f630.svg";